import { useEffect, useState } from "react";

const useHubspotChat = (enabled = true) => {
  // Initially set to true until proven otherwise
  // This will prevent us from showing the fallback widget before we know if the script is blocked
  const [scriptLoaded, setScriptLoaded] = useState(true);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const portalId = 2409126;

    // Create script component
    const script = document.createElement("script");
    script.src = `//js.hs-scripts.com/${portalId}.js`;
    script.async = true;

    document.body.appendChild(script);

    // Check for the presence of the HubSpot chat class
    const checkHubspotClass = () => {
      const hubspotElement = document.querySelector("#hubspot-messages-iframe-container");
      if (!hubspotElement) {
        console.error("HubSpot script loading failed or blocked.");
        setScriptLoaded(false);
      } else {
        setScriptLoaded(true);
      }
    };

    // Wait for the script to load and check for the class after a delay
    script.onload = () => {
      setTimeout(checkHubspotClass, 5000);
    };

    return () => {
      // Remove script from the body
      document.body.removeChild(script);
    };
  }, [enabled]);

  // Return the script loading status
  return scriptLoaded;
};

export default useHubspotChat;
